"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SlicesItem = _interopRequireDefault(require("./SlicesItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Slices extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderSlice", (slice, index) => {
      const _this$props = this.props,
            tooltip = _this$props.tooltip,
            debug = _this$props.debug,
            axis = _this$props.axis,
            height = _this$props.height,
            setCurrent = _this$props.setCurrent,
            current = _this$props.current;
      const isCurrent = current && current.id === slice.id;
      return _react.default.createElement(_SlicesItem.default, {
        key: slice.id,
        slice: slice,
        axis: axis,
        debug: debug,
        height: height,
        tooltip: tooltip,
        setCurrent: setCurrent,
        isCurrent: isCurrent || false
      });
    });
  }

  render() {
    const slices = this.props.slices;

    if (!slices) {
      return false;
    }

    return _react.default.createElement("g", {
      className: "slices"
    }, slices.map(this.renderSlice));
  }

}

var _default = (0, _react.memo)(Slices);

exports.default = _default;
module.exports = exports.default;